// extracted by mini-css-extract-plugin
export default {"container":"BannerHome_container__9gX3b","image":"BannerHome_image__nc+5e"};